<template>
  <v-layout justify-center>
    <v-flex xs12 sm10 md8 lg10>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card ref="upload-form" v-model="valid">
              <v-card-text>
                <v-select label="Naam opdrachtgever" v-model="selectedClient" :items="clients" item-text="name"
                          item-value="id" return-object @change="populateAreas"></v-select>
                <v-select label="Kies wijk" v-model="selectedArea" :items="areaitems"></v-select>
                <v-select label="Uit te voeren werkzaamheden" v-model="selectedJob" :items="jobs"
                          v-if="jobs.length > 0"></v-select>
                <v-text-field label="Opdrachtkenmerk" v-model="idAssignment"></v-text-field>
                <div @click="$refs.inputUpload.click()">
                  <v-text-field
                      label="Adressenbestand"
                      prepend-icon="attach_file"
                      v-model="filename"
                      readonly
                  ></v-text-field>
                </div>
                <input
                    v-show="false"
                    accept="text/csv"
                    ref="inputUpload"
                    type="file"
                    @change="handleFileUpload()"
                >
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="save()" color="primary" :disabled="notReadyToSubmit">Opslaan</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <v-snackbar bottom :timeout="5000" v-model="uploadSuccesful">{{ count }} addressen ge&iuml;mporteerd.</v-snackbar>
    <v-snackbar bottom :timeout="5000" v-model="errorOccurred">Import is mislukt.</v-snackbar>
  </v-layout>
</template>

<script>
import {adminService} from "@/services/admin";
import {jobService} from "@/services/address";
import {mapActions, mapGetters} from "vuex";

export default {
  data: () => ({
    selectedClient: null,
    selectedArea: null,
    areaitems: [],
    selectedJob: null,
    jobs: [],
    idAssignment: null,
    file: null,
    filename: null,
    count: 0,
    uploadSuccesful: false,
    errorOccurred: false,
    valid: undefined,
    sending: false
  }),
  computed: {
    ...mapGetters({
      clients: "clientList",
    }),
    notReadyToSubmit() {
      let readyToSubmit = true;
      if (this.selectedClient === null) {
        readyToSubmit = false;
      }
      if (this.selectedArea === null) {
        readyToSubmit = false;
      }
      if (this.selectedJob === null && this.jobs.length > 0) {
        readyToSubmit = false;
      }
      if (this.idAssignment === null || this.idAssignment.length < 4) {
        readyToSubmit = false;
      }
      if (this.filename === null) {
        readyToSubmit = false;
      }

      return !readyToSubmit;
    }
  },
  methods: {
    ...mapActions([
      "loadClients"
    ]),
    handleFileUpload() {
      this.file = this.$refs.inputUpload.files[0];
      this.filename = this.file.name;
    },
    clear() {
      this.idAssignment = null;
      this.selectedClient = null;
      this.file = null;
      this.filename = null;
      this.selectedArea = null;
      this.selectedJob = null
      this.areaitems = [];
    },
    populateAreas() {
      if (this.selectedClient) {
        this.areaitems = this.selectedClient.areas;
      }
    },
    save() {
      this.sending = true;

      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("clientId", this.selectedClient.id);
      formData.append("assignment", this.idAssignment);
      formData.append("area", this.selectedArea);

      if (this.jobs.length > 0) {
        formData.append("job", this.selectedJob);
      }

      let self = this;

      adminService.saveAddresses(formData)
          .then((response) => {
            self.sending = false;
            self.clear();
            self.count = response.data.countImported;
            self.errorOccurred = false;
            self.uploadSuccesful = true;
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.warn("error occurred: ", error);
            self.errorOccurred = true;
            self.clear();
          });
    }
  },
  created() {
    this.loadClients();
    jobService.resolveJobs().then(result => {
      if (result.data) {
        this.jobs = result.data.map(a => a.name);
      }
    })
  }
};
</script>
